import { render, staticRenderFns } from "./StayOrder.vue?vue&type=template&id=2aa4bcd5&scoped=true&"
import script from "./StayOrder.vue?vue&type=script&lang=js&"
export * from "./StayOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa4bcd5",
  null
  
)

export default component.exports